/**
 * MarqueeText 컴포넌트
 *
 * 텍스트가 컨테이너보다 길 경우 자동으로 스크롤되는 마키 효과를 적용합니다.
 * 모바일에서 긴 제목/아티스트명을 보여줄 때 유용합니다.
 */

import { useRef, useEffect, useState } from 'react'

interface MarqueeTextProps {
  text: string
  className?: string
}

export function MarqueeText({ text, className = '' }: MarqueeTextProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLSpanElement>(null)
  const [shouldAnimate, setShouldAnimate] = useState(false)

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && textRef.current) {
        const containerWidth = containerRef.current.offsetWidth
        const textWidth = textRef.current.scrollWidth
        setShouldAnimate(textWidth > containerWidth)
      }
    }

    checkOverflow()

    // 윈도우 리사이즈 시 다시 체크
    window.addEventListener('resize', checkOverflow)
    return () => window.removeEventListener('resize', checkOverflow)
  }, [text])

  if (!shouldAnimate) {
    // 텍스트가 짧으면 그냥 truncate
    return (
      <div ref={containerRef} className={`overflow-hidden ${className}`}>
        <span ref={textRef} className="block truncate">{text}</span>
      </div>
    )
  }

  // 텍스트가 길면 마키 애니메이션
  return (
    <div ref={containerRef} className={`marquee-container ${className}`}>
      <span
        ref={textRef}
        className="marquee-content animate"
        data-text={text}
      >
        {text}
      </span>
    </div>
  )
}
